import type { AuthSessionUser } from './types';
import { fetchWithRetry } from '../lib/http';

export async function getSession(): Promise<AuthSessionUser | null> {
  const res = await fetchWithRetry('/auth/session', {
    method: 'GET',
    credentials: 'include'
  });

  if (res.status === 401) return null;
  if (!res.ok) {
    throw new Error(`Session request failed (${res.status})`);
  }

  const payload = (await res.json()) as { authenticated?: boolean; user?: AuthSessionUser };
  return payload.authenticated && payload.user ? payload.user : null;
}

export async function logout(): Promise<void> {
  await fetch('/auth/logout', {
    method: 'POST',
    credentials: 'include'
  });
}

export async function getFirebaseCustomToken(): Promise<string> {
  const res = await fetchWithRetry('/auth/firebase/token', {
    method: 'GET',
    credentials: 'include'
  });

  if (res.status === 401) {
    throw new Error('Unauthenticated');
  }
  if (!res.ok) {
    throw new Error(`Firebase token request failed (${res.status})`);
  }

  const payload = (await res.json()) as { token?: string };
  if (!payload.token) throw new Error('Firebase token payload missing token');
  return payload.token;
}

export function loginUrl(returnTo: string): string {
  const params = new URLSearchParams({ returnTo });
  return `/auth/wa/login?${params.toString()}`;
}
